import React, { useState, useEffect } from 'react';

const CmtFaq = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      lineHeight: 1.6,
      color: '#333',
      backgroundColor: '#f8f9fa',
      minHeight: '100vh'
    },
    header: {
      backgroundColor: 'white',
      padding: isMobile ? '1.5rem 0' : '2rem 0',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    headerContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: isMobile ? '0 1rem' : '0 2rem',
      textAlign: 'center'
    },
    headerTitle: {
      fontSize: isMobile ? '1.8rem' : '2.5rem',
      color: '#2c3e50',
      marginBottom: '1rem',
      letterSpacing: '-0.5px',
      fontWeight: '300',
      textAlign: 'left'
    },
    mainContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: isMobile ? '2rem 1rem' : '3rem 2rem'
    },
    topSection: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'auto 1fr',
      gap: isMobile ? '2rem' : '3rem',
      alignItems: 'start',
      marginBottom: isMobile ? '3rem' : '4rem'
    },
    logoContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: 'white',
      padding: '1.5rem',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
    },
    logo: {
      width: '120px',
      height: '120px',
      borderRadius: '50%',
      border: '4px solid #0f4c75',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'white',
      marginBottom: '1rem'
    },
    logoContent: {
      textAlign: 'center',
      color: '#0f4c75'
    },
    logoText: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      marginBottom: '0.5rem'
    },
    logoBars: {
      display: 'flex',
      justifyContent: 'center',
      gap: '2px',
      marginBottom: '0.5rem'
    },
    logoBar: {
      width: '8px',
      height: '24px',
      borderRadius: '1px'
    },
    logoProvider: {
      fontSize: '0.7rem',
      display: 'flex',
      alignItems: 'center'
    },
    logoProviderText: {
      transform: 'rotate(-90deg)',
      fontSize: '0.6rem'
    },
    logoSource: {
      fontSize: '0.8rem',
      color: '#666',
      textAlign: 'center'
    },
    videoContainer: {
      width: '100%',
      height: isMobile ? '200px' : '300px',
      backgroundColor: '#f0f0f0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px solid #ddd',
      borderRadius: '8px',
      position: 'relative',
      backgroundImage: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white'
    },
    videoContent: {
      textAlign: 'center',
      position: 'relative',
      zIndex: 2
    },
    playButton: {
      width: isMobile ? '60px' : '80px',
      height: isMobile ? '60px' : '80px',
      backgroundColor: 'rgba(255,255,255,0.9)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 1rem',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },
    videoTitle: {
      fontSize: isMobile ? '1rem' : '1.2rem',
      fontWeight: 'bold',
      marginBottom: '0.5rem',
      textShadow: '0 2px 4px rgba(0,0,0,0.3)'
    },
    videoDescription: {
      fontSize: isMobile ? '0.8rem' : '0.9rem',
      opacity: 0.9
    },
    titleSection: {
      textAlign: 'center',
      marginBottom: '3rem'
    },
    mainTitle: {
      fontSize: isMobile ? '1.8rem' : '2.2rem',
      fontWeight: 'bold',
      color: '#2c3e50',
      marginBottom: '1rem'
    },
    titleUnderline: {
      width: '100px',
      height: '3px',
      backgroundColor: '#060505ff',
      margin: '0 auto',
      borderRadius: '2px'
    },
    faqGridContainer: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
      gap: isMobile ? '1rem' : '1.5rem',
      marginTop: isMobile ? '1.5rem' : '2rem',
    },
    faqCard: {
      backgroundColor: 'white',
      borderRadius: '8px',
      padding: isMobile ? '1rem' : '1.25rem',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      border: '1px solid #eaeaea',
      transition: 'all 0.2s ease',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    faqCardHover: {
      boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
      transform: 'translateY(-2px)',
    },
    faqCardContent: {
      display: 'flex',
      gap: isMobile ? '0.75rem' : '1rem',
      alignItems: 'flex-start',
      flex: 1,
    },
    faqCardIcon: {
      flexShrink: 0,
      padding: isMobile ? '0.5rem' : '0.6rem',
      backgroundColor: '#f8f9fa',
      borderRadius: '6px',
      border: '1px solid #e9ecef',
    },
    faqCardIconSmall: {
      width: isMobile ? '28px' : '32px',
      height: isMobile ? '28px' : '32px',
      color: '#09547fff',
    },
    faqCardText: {
      flex: 1,
    },
    faqCardTitle: {
      fontSize: isMobile ? '1rem' : '1.1rem',
      fontWeight: '600',
      color: '#2c3e50',
      marginBottom: isMobile ? '0.5rem' : '0.75rem',
      lineHeight: 1.3,
    },
    faqCardDescription: {
      fontSize: isMobile ? '0.85rem' : '0.9rem',
      color: '#555',
      lineHeight: 1.5,
    },
    footerSection: {
      textAlign: 'center',
      marginTop: isMobile ? '3rem' : '4rem',
      padding: isMobile ? '1.5rem' : '2rem',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
    },
    footerTitle: {
      fontSize: isMobile ? '1.3rem' : '1.5rem',
      fontWeight: 'bold',
      color: '#2c3e50',
      marginBottom: '1rem'
    },
    footerDescription: {
      color: '#666',
      fontSize: isMobile ? '0.9rem' : '1rem',
      marginBottom: '1.5rem',
      maxWidth: '600px',
      margin: '0 auto 1.5rem'
    },
    footerButton: {
      backgroundColor: '#09547fff',
      color: 'white',
      padding: isMobile ? '0.6rem 1.5rem' : '0.75rem 2rem',
      fontSize: isMobile ? '0.9rem' : '1rem',
      fontWeight: 'bold',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    }
  };

  const faqData = [
    {
      title: "What is the CMT Program?",
      description: "CMT Program was created in 1989 and is administered by the CMT Association (formerly known as MTA). The CMT Association is a global credentialing body.",
    },
    {
      title: "Is CMT (chartered market technician) worth it?",
      description: "CMT designation helps you to distinguish yourself among thousands of technical analysts around the globe. The intense Program fill any learning gaps you may have for understanding Technical Analysis concepts.",
    },
    {
      title: "How To Become A Chartered Market Technician® (CMT)?",
      description: "To earn your CMT designation, here are three main steps you'll need to follow to start your career: Step 1: Pass all three levels of the CMT Exam. Step 2: Become a CMT Association's Member. Step 3: Complete Work Experience Requirements. You should have at least 3 Years of relevant work experience.",
    },
    {
      title: "How much do CMT make?",
      description: "It all depends on your personal skills and ability to gauge market with the CMT knowledge base.",
    },
    {
      title: "How long does it take to study for CMT & become CMT charterholder?",
      description: "It takes almost 3 years in most cases to get CMT designation. The pace of exam and each exam is different so in year 6 is your place and require opportunities for CMT designation as well, so you need at least 18 months of in-depth study.",
    },
    {
      title: "How often is the CMT exam offered?",
      description: "The CMT exams are set to take place twice each year, in the months of June and December spanning a duration of two weeks each time. This schedule is relaxation for the exam year. It's important to note that the CMT exam could be offered 3 or 4 times each year internationally.",
    }
  ];

  // Icon components
  const IconBookSmall = () => (
    <svg style={styles.faqCardIconSmall} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C20.168 18.477 18.582 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
    </svg>
  );

  const IconBadge = () => (
    <svg style={styles.faqCardIconSmall} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );

  const IconPath = () => (
    <svg style={styles.faqCardIconSmall} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
  );

  const IconDollar = () => (
    <svg style={styles.faqCardIconSmall} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
    </svg>
  );

  const IconClock = () => (
    <svg style={styles.faqCardIconSmall} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );

  const IconCalendar = () => (
    <svg style={styles.faqCardIconSmall} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  );

  const handleButtonHover = (e, isEnter) => {
    if (isEnter) {
      e.target.style.backgroundColor = '#0a466d';
      e.target.style.transform = 'translateY(-2px)';
    } else {
      e.target.style.backgroundColor = '#09547fff';
      e.target.style.transform = 'translateY(0)';
    }
  };

  return (
    <div style={styles.container}>
      {/* Header Section */}
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <h1 style={styles.headerTitle}>
            CHARTERED MARKET TECHNICIAN (FAQ)
          </h1>
        </div>
      </div>

      {/* Main Content */}
      <div style={styles.mainContent}>
        {/* Logo and Video Section */}
        

        {/* FAQ Grid Section */}
        <div>
          <div style={styles.titleSection}>
            
          </div>
          
          <div style={styles.faqGridContainer}>
            {faqData.map((faq, index) => (
              <div 
                key={index}
                style={styles.faqCard}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = styles.faqCardHover.boxShadow;
                  e.currentTarget.style.transform = styles.faqCardHover.transform;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = styles.faqCard.boxShadow;
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={styles.faqCardContent}>
                  <div style={styles.faqCardIcon}>
                    {index === 0 && <IconBookSmall />}
                    {index === 1 && <IconBadge />}
                    {index === 2 && <IconPath />}
                    {index === 3 && <IconDollar />}
                    {index === 4 && <IconClock />}
                    {index === 5 && <IconCalendar />}
                  </div>
                  <div style={styles.faqCardText}>
                    <h4 style={styles.faqCardTitle}>
                      {faq.title}
                    </h4>
                    <p style={styles.faqCardDescription}>
                      {faq.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer Section */}
        <div style={styles.footerSection}>
          <h3 style={styles.footerTitle}>
            Ready to Start Your CMT Journey?
          </h3>
          <p style={styles.footerDescription}>
            Join thousands of professionals who have advanced their careers with the CMT designation.
          </p>
          <button 
            style={styles.footerButton}
            onMouseEnter={(e) => handleButtonHover(e, true)}
            onMouseLeave={(e) => handleButtonHover(e, false)}
          >
            Get Started Today
          </button>
        </div>
      </div>
    </div>
  );
};

export default CmtFaq;